//formula: https://www.gs1.org/services/how-calculate-check-digit-manually
//calculator: https://www.gs1.org/services/check-digit-calculator

export const checksum = (val: string) => {
    const ean = val.trim();
    const length = ean.length;
    // input has 8, 13, or 14 digits
     if (typeof ean !== 'string' || !/^\d+$/.test(ean) || ![8, 13, 14].includes(length)) {
        return false;
    }
    const digits = ean.split('').map(Number);
    let sum = 0;
    let checksumDigitIndex;
    if (length === 8) {
        checksumDigitIndex = 7;
        for (let i = 0; i < 7; i++) {
            sum += digits[i] * (i % 2 === 0 ? 3 : 1); // Multiply by 3 if even, by 1 if odd
        }
    } else if (length === 13) {
        checksumDigitIndex = 12;
        for (let i = 0; i < 12; i++) {
            sum += digits[i] * (i % 2 === 0 ? 1 : 3); // Multiply by 1 if even, by 3 if odd
        }
    } else if (length === 14) {
        checksumDigitIndex = 13;
        for (let i = 0; i < 13; i++) {
            sum += digits[i] * (i % 2 === 0 ? 3 : 1); // Multiply by 3 if even, by 1 if odd
        }
    }
    // The checksum makes the sum a multiple of 10
    const checksumDigit = (10 - (sum % 10)) % 10;
    if(checksumDigitIndex === undefined){
        return false;
    }
    return checksumDigit === digits[checksumDigitIndex];
}


export const calclastdigit = (val: string) => {
    const ean = val.trim();
    const length = ean.length;
     if (typeof ean !== 'string' || !/^\d+$/.test(ean) || ![7, 12, 13].includes(length)) {
        return "";
    }
    const digits = ean.split('').map(Number);
    let sum = 0;
    if (length === 7) {
        for (let i = 0; i < 7; i++) {
            sum += digits[i] * (i % 2 === 0 ? 3 : 1); // Multiply by 3 if even, by 1 if odd
        }
    } else if (length === 12) {
        for (let i = 0; i < 12; i++) {
            sum += digits[i] * (i % 2 === 0 ? 1 : 3); // Multiply by 1 if even, by 3 if odd
        }
    } else if (length === 13) {
        for (let i = 0; i < 13; i++) {
            sum += digits[i] * (i % 2 === 0 ? 3 : 1); // Multiply by 3 if even, by 1 if odd
        }
    }
    // The checksum makes the sum a multiple of 10
    const checksumDigit = (10 - (sum % 10)) % 10;
    return checksumDigit.toString();
}

export const checkSum = (tmpCode: string) => {
    let sum = 0;
    for (let i = tmpCode.length - 1; i >= 0; i--) {
        let digit = parseInt(tmpCode[i], 10);
        sum += digit * ((tmpCode.length - 1 - i) % 2 === 0 ? 3 : 1);
    }
    let checkSumDigit = (10 - (sum % 10)) % 10;
    return checkSumDigit.toString();
}